// extracted by mini-css-extract-plugin
module.exports = {"content":"TuitionFees_content__2Gk8O","text":"TuitionFees_text__3lWPR","image10":"TuitionFees_image10__hUp9f"};